import { IconButton, InputAdornment, TextField } from "@mui/material";
import X_Circle from "../../../../../../Assets/Icons/x-circle.svg";
import { useState } from "react";
import axiosInstance from "../../../../../../axiosInstance";

const RenameModal = ({ projectId, projectName, onClose, onRenameSuccess }) => {
  const [currentWeddingName, setCurrentWeddingName] = useState(projectName);
  const [renameHasError, setRenameHasError] = useState(false);

  const handleNameChange = (e) => {
    setCurrentWeddingName(e.target.value);
    setRenameHasError(false);
  };

  const handleClear = () => {
    setCurrentWeddingName("");
    setRenameHasError(false);
  };

  const handleRename = () => {
    const fullUrl =
      window.localStorage.getItem("BaseURL") +
      `/services/projectmanagement/api/projects/${projectId}`;

    const params = {
      id: Number(projectId) || 0,
      name: currentWeddingName,
    };

    axiosInstance
      .patch(fullUrl, params)
      .then((res) => onRenameSuccess(res.data))
      .catch((err) => {
        console.error(err);
        setRenameHasError(true);
      });
  };

  return (
    <>
      <div className="overlay" onClick={onClose} />

      <div className="modal">
        <h1>Rename {projectName}</h1>
        <TextField
          autoComplete="off" // Disable autofill
          fullWidth
          id="name"
          name="name"
          label="Name"
          placeholder=""
          variant="outlined"
          value={currentWeddingName}
          onChange={handleNameChange}
          error={renameHasError}
          helperText={
            renameHasError ? "Wedding with the same title exists" : ""
          }
          margin="normal"
          sx={{
            "& .MuiInputLabel-root.Mui-focused": {
              color: "#171717",
            },
            "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
              {
                borderColor: "#79747E", // Change border color when focused
              },
            "& .MuiInputBase-root": {
              borderRadius: "8px",
              height: "50px", // Set the height of the input field to 50px
            },
            backgroundColor: "transparent",
            borderRadius: "4px",
            borderBottom: "none",
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                {currentWeddingName && ( // Render clear button only if name has value
                  <IconButton
                    aria-label="clear name"
                    onClick={handleClear}
                    edge="end"
                    style={{ color: "#FB4764" }}
                  >
                    <img alt="x" src={X_Circle} />
                  </IconButton>
                )}
              </InputAdornment>
            ),
          }}
        />
        <section>
          <span onClick={onClose}>Cancel</span>
          <span
            className={!currentWeddingName.length ? "disabled-action" : ""}
            onClick={handleRename}
          >
            Save
          </span>
        </section>
      </div>
    </>
  );
};

export default RenameModal;
